export const featureDataCommercialExteriorPainting = {
    mainTitle: 'Why Choose HRD for Exterior Painting?',
    items: [
        {
            number: '01',
            heading: 'Premium-Grade Paints & Coatings – We use high-performance, UV- resistant, and weatherproof coatings for maximum protection.'
        },
        {
            number: '02',
            heading: 'Skilled & Certified Painters – Our experienced team ensures flawless application and long-lasting results.'
        },
        {
            number: '03',
            heading: 'Minimal Disruption – We work efficiently to complete projects on time and with minimal impact on tenants and businesses.'
        },
        {
            number: '04',
            heading: 'Comprehensive Surface Preparation – Power washing, priming, and repairs to ensure optimal adhesion and durability.'
        },
        {
            number: '05',
            heading: 'Safety & Compliance – Adhering to all industry standards for high-rise and commercial painting projects.'
        }
    ],
    title: "Transform & Protect Your Property",
    subtitle:
        'From office towers and retail centers to hotels, warehouses, and industrial facilities, our expert painting solutions help you maintain a professional and polished exterior while ensuring long-term surface protection.',
    ctaText:
        'CONTACT US TODAY TO DISCUSS HOW WE CAN PROTECT AND ENHANCE YOUR PROPERTY!',
    backgroundImage: '/assets/imgs/services/3CommercialExteriorPainting/featuregridSection/fondo.png'
};
